import { z } from "zod";
export const getStickyContactSchema = (t, opts) => {
    if (!opts.isStickyContactForm)
        return z.object({});
    return z.object({
        householdType: z.enum(["1", "2", "3", "4"], {
            invalid_type_error: t("contact.form.household_type_error_empty"),
        }),
        workStatus: z.enum(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"], {
            invalid_type_error: t("contact.form.work_status_error_empty"),
        }),
        netMonthlyIncome: z.enum(["1", "2", "3", "4", "5", "6", "7", "8", "9"], {
            invalid_type_error: t("contact.form.net_monthly_income_error_empty"),
        }),
        preferredMoveInDate: z.enum(["1", "2", "3", "4", "5"], {
            invalid_type_error: t("contact.form.preferred_move_in_date_error_empty"),
        }),
    });
};
